import DDivider from './src';

DDivider.install = Vue => {
  Vue.component('DDivider', DDivider);
};

export default DDivider;
